<template>
  <div
    v-if="show"
    class="modal-overlay"
    @click.self="closeModal"
  >
    <div class="modal-container">
      <button
        class="close-button"
        @click="closeModal"
      >
        &times;
      </button>
      <div class="modal-header">
        <div>
          <h5>{{ notification.titulo }}</h5>
          <div class="">
            <p v-html="notification.descricao" />
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div v-html="notification.mensagem" />
      </div>
      <small class="text-muted">{{ formatDate(notification.dataCadastro) }}</small>
    </div>
  </div>
</template>

<script>
// import notificacao from '@/@pilar/plugins/notificacao'

export default {
  name: 'NotificationModal',
  props: {
    notification: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-notification-modal')
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString(undefined, options)
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050; /* Aumentado para garantir que fique acima do drawer */
}

.modal-container {
  background: white;
  padding: 15px 20px;
  border-radius: 12px;
  width: 600px;
  max-width: 90%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80%; /* Aumentando o espaço para o conteúdo */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .5rem;
  padding: 5px;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.7rem;
  cursor: pointer;
  align-self: flex-end;
}

.modal-body {
  flex-grow: 1; /* Permite que o conteúdo ocupe mais espaço */
  overflow-y: auto; /* Adiciona rolagem caso o conteúdo exceda o tamanho */
  font-size: 1.1rem;
  color: #333;
}

.text-muted {
  color: #6c757d;
}
</style>
